import {EquipmentPinModel} from './equipment-pin.model';

export interface CableCoreModel {
    id?: string;
    title?: string;
    cableId?: string | null;
    equipmentInPinId?: string | null;
    equipmentOutPinId?: string | null;
    equipmentInCapId?: string | null;
    equipmentOutCapId?: string | null;
    locationConnectionId: string;
    sortOrder: number;
    created?: string;
    isActive: boolean;

    coreType?: string | null;
    coreRatedCurrent?: string | null;
    coreCrossSection?: string | null;
    coreIntrinsicSafety?: boolean | null;
    coreMaterial?: string | null;
    coreFunction?: string | null;

    equipmentInPin?: EquipmentPinModel;
    equipmentOutPin?: EquipmentPinModel;
}

export class CreateEditCableCoreViewModel implements Omit<CableCoreModel, 'id' | 'created' | 'isActive' | 'sortOrder' | 'equipmentInPin' | 'equipmentOutPin'> {
    id?: string;
    title?: string;
    cableId?: string | null;
    equipmentInPinId?: string | null;
    equipmentOutPinId?: string | null;
    locationConnectionId: string;
    // sortOrder: number;

    coreType?: string | null;
    coreRatedCurrent?: string | null;
    coreCrossSection?: string | null;
    coreIntrinsicSafety?: boolean | null;
    coreMaterial?: string | null;
    coreFunction?: string | null;

    constructor(data: CreateEditCableCoreViewModel) {
        Object.assign(this, data);
    }
}

export interface UpdateCableCoreSortOrderModel {
    dragedCableCoreId: string;
    targetCableCoreId: string;
    where: 'before' | 'after';
}
